import React from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '../styles/filter.scss';

const Filter = (props) => {
  const { date,members,types,payments,methods,onClose,onMembersChange,onTypeChange,onPaymentChange,onMethodChange,onDateChange } = props;
  return (
    <div id="filter" onClick={onClose}>
      <div className="panel">
        <div className="block">
          <h5>成員</h5>
          <div className="row">
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("collar") ? 'selected' : '')} data-member="collar" onClick={onMembersChange}>Collar</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("candy") ? 'selected' : '')} data-member="candy" onClick={onMembersChange}>Candy</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("day") ? 'selected' : '')} data-member="day" onClick={onMembersChange}>Day</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("gao") ? 'selected' : '')} data-member="gao" onClick={onMembersChange}>Gao</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("ivy") ? 'selected' : '')} data-member="ivy" onClick={onMembersChange}>Ivy</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("marf") ? 'selected' : '')} data-member="marf" onClick={onMembersChange}>Marf</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("soching") ? 'selected' : '')} data-member="soching" onClick={onMembersChange}>SoChing</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("sumling") ? 'selected' : '')} data-member="sumling" onClick={onMembersChange}>SumLing</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button member " + (members.includes("winka") ? 'selected' : '')} data-member="winka" onClick={onMembersChange}>Winka</button>
            </div>
          </div>
        </div>
        <div className="block">
          <h5>收費</h5>
            <div className="row">
              <div className="col-6 col-sm-2">
                <button className={"button payment " + (payments.includes("free") ? 'selected' : '')} data-payment="free" onClick={onPaymentChange}>免費</button>
              </div>
              <div className="col-6 col-sm-2">
                <button className={"button payment " + (payments.includes("paid") ? 'selected' : '')} data-payment="paid" onClick={onPaymentChange}>金主</button>
              </div>
            </div>
        </div>
        <div className="block">
          <h5>狀況</h5>
            <div className="row">
              <div className="col-6 col-sm-2">
                <button className={"button type " + (types.includes("reserve") ? 'selected' : '')} data-type="reserve" onClick={onTypeChange}>預留</button>
              </div>
              <div className="col-6 col-sm-2">
                <button className={"button type " + (types.includes("walkin") ? 'selected' : '')} data-type="walkin" onClick={onTypeChange}>派發</button>
              </div>
              <div className="col-6 col-sm-2">
                <button className={"button type " + (types.includes("preview") ? 'selected' : '')} data-type="preview" onClick={onTypeChange}>預告</button>
              </div>
            </div>
        </div>
        <div className="block">
          <h5>派發方式</h5>
          <div className="row">
            <div className="col-6 col-sm-2">
              <button className={"button method " + (methods.includes("inPerson") ? 'selected' : '')} data-method="inPerson" onClick={onMethodChange}>親自派發</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button method " + (methods.includes("shop") ? 'selected' : '')} data-method="shop" onClick={onMethodChange}>應援店</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button method " + (methods.includes("post") ? 'selected' : '')} data-method="post" onClick={onMethodChange}>郵寄</button>
            </div>
            <div className="col-6 col-sm-2">
              <button className={"button method " + (methods.includes("sf") ? 'selected' : '')} data-method="sf" onClick={onMethodChange}>順豐</button>
            </div>
          </div>
        </div>
        <div className="block">
          <h5>時間</h5>
          <DateRange
            editableDateInputs={true}
            onChange={onDateChange}
            moveRangeOnFirstSelection={false}
            ranges={date}
          />
        </div>
      </div>
    </div>
  )
}

export default Filter;
